import React from "react";
import { space18 } from "../dist/helpers"
// import { SpriteFourStep } from "../routes/Experimental";
// import ArrowController2 from "./ArrowController2";
// import TestComponent from "./TestComponent";
import Fingerprint from "./Fingerprint"


export default function DemoPage1() {

  async function cookieTest() {
  // Set test cookie
    try {
      await window.cookieStore.set("cookie1", "cookie1-value");
    } catch (error) {
      console.log(`Error setting cookie1: ${error}`);
    }

    // Get cookie, specifying name
    const cookie = await window.cookieStore.get("cookie1");

    if (cookie) {
      console.log(cookie);
    } else {
      console.log("cookie1: Cookie not found");
    }
  }

  cookieTest()

  // const [count, setCount] = React.useState(0);
  // let frame = Math.round(count);
  // const images = require.context('../images/bulba', true);
  // const imageList = images.keys().map(image => images(image));
  // let direction = "0" // down
  // const requestRef = React.useRef();
  // const previousTimeRef = React.useRef();

  // const animate = time => {
  //   if (previousTimeRef.current !== undefined) {
  //     const deltaTime = time - previousTimeRef.current;

  //     // This last mod is the range
  //     // the decimal is speed of animation
  //     setCount(prevCount => (prevCount + deltaTime * 0.0035) % 3);
  //   }
  //   previousTimeRef.current = time;
  //   requestRef.current = requestAnimationFrame(animate);
  // }

  // React.useEffect(() => {
  //   requestRef.current = requestAnimationFrame(animate);
  //   return () => cancelAnimationFrame(requestRef.current);
  // });

  // const testStyle = (
  //   {
  //     backgroundColor: "#f1f1f1",
  //     border: "1px solid black",
  //     padding: "20px",
  //     fontSize: "30px",
  //     textAlign: "center",
  //   }
  // )

  return (
    <>
      <Fingerprint />
      {/* <div style={{margin: "50px 50px 50px 50px"}}>
        <h1> under construction </h1>
        <h1> under construction </h1>
        <h1> under construction </h1>
        <p> under construction </p>
        <p> under construction </p>
        <p> under construction </p>
        <p> under construction </p>

        <div style={{
          display: "grid",
          gridTemplateColumns: "auto auto auto",
          backgroundColor: "dodgerblue",
          padding: "10px"
        }}>
          <div style={testStyle} >1</div>
          <center>
            {SpriteFourStep(frame, imageList[0], 0, direction)}
          </center>
          <div style={testStyle} >2</div>
          <div style={testStyle} >3</div>
          <div style={testStyle} >4</div>
          <div style={testStyle} >5</div>
          <div style={testStyle} >6</div>
          <div style={testStyle} >7</div>
          <div style={testStyle} >8</div>
        </div>

        <ArrowController2></ArrowController2>
        { space18 }
        <TestComponent></TestComponent>
        { space18 }

      </div> */}
      { space18 }
      <footer className="pt-3 mt-4 text-muted border-top" />
      { space18 }
      <footer className="pt-3 mt-4 text-muted border-top" />
    </>
  );
}
